import React from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import {
    RiArchiveFill,
    RiBookFill,
    RiBookMarkedFill, RiBrain2Fill, RiChatSmile2Fill, RiCompass2Fill, RiEditFill, RiFlowChart,
    RiFolderMusicLine, RiHomeSmileFill,
    RiMusic2Fill, RiUserVoiceLine, RiVoiceAiFill
} from "react-icons/ri";
import withNavigateHook from "../hooks/withNavigationHook";
import {RiDeleteBinFill} from "@remixicon/react";
import AutoCompleteInput from "./song/AutoCompleteInput";
import {SeoHelper} from "../components/helpers/SeoHelper";
import CuratedSongFlowSignupBanner from "../components/helpers/CuratedSongFlowSignupBanner";

class Index extends React.Component {
    state = {};

    componentDidMount() {
        // Preload themes to reduce lag
        if (sessionStorage.getItem("themes") === null || JSON.parse(sessionStorage.getItem("themes")).length === 0) {
            // Api.get(`/themes?includeSongCount=true`)
            //     .then(res => {
            //         const listItems = res.data;
            //         sessionStorage.setItem("themes", JSON.stringify(listItems));
            //         this.setState({listItems: listItems});
            //     })
        } else {
            this.setState({listItems: JSON.parse(sessionStorage.getItem("themes"))});
        }

        sessionStorage.removeItem("selected-passages")
    }
    clearDownDraft = () => {
        sessionStorage.removeItem("curated-songs");
        sessionStorage.removeItem("playlist");
        this.props.navigation(0);
    }

    render() {
        return <>
            <SeoHelper
                uri = "/"
                title = "The Worship Bible"
                description={"A resource for building worship service plans based on scripture, themes, and the lectionary."}
            />
            <div className="position-relative">
                {/* shape Hero */}
                <section className="section section-lg section-shaped pb-10">
                    <div className="shape shape-style-1 shape-default">
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                    </div>
                    <Container className="py-lg-md d-flex">
                        <div className="col px-0">
                            <Row>
                                <Col lg="8">
                                    <h1 className="display-3 text-white">
                                        Build worship services{" "}
                                        <span>around scripture</span>
                                    </h1>
                                    <p className="lead text-white">
                                        Find songs for your passages, themes, and lectionary readings. Create an account to save and build your worship service plans.
                                    </p>
                                    {/*<div className="btn-wrapper">*/}
                                    {/*  <Button*/}
                                    {/*    className="btn-icon mb-3 mb-sm-0"*/}
                                    {/*    color="primary"*/}
                                    {/*    href="/do-you-use-a-lectionary-or-song-book"*/}
                                    {/*  >*/}
                                    {/*    <span className="btn-inner--icon mr-1">*/}
                                    {/*      <i className="fa fa-music" />*/}
                                    {/*    </span>*/}
                                    {/*    <span className="btn-inner--text">Generate a Worship Playlist</span>*/}
                                    {/*  </Button>*/}
                                    {/*</div>*/}
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    {/* SVG separator */}
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                {/* 1st Hero Variation */}
            </div>
            <section className="section pt-lg-0">
                <Container>
                    {(
                        (sessionStorage.getItem("curated-songs") && sessionStorage.getItem("curated-songs") != 'null' && JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 && !sessionStorage.getItem("playlist"))
                    ) && <>
                    <Row className="justify-content-center">
                        <Col lg="12">
                            <Card className="card-lift--hover shadow border-0 mb-4">
                                <CardBody className="py-5">
                                    <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase d-flex align-items-center">
                                        <div className="icon icon-shape icon-shape-primary rounded-circle">
                                            <RiFolderMusicLine/>
                                        </div>
                                        <span className="ml-3">Service plan</span>
                                    </h2>
                                    <p className="description mt-3">
                                    What would you like to do with your draft service plan?
                                    </p>
                                    <Row className="mt-4 btn-wrapper">
                                        <Button
                                            className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                            color="primary"
                                            href="/scripture/curated-songs"
                                        >
                                                  <span className="btn-inner--icon mr-1">
                                                    <RiEditFill title="Edit" size="16"/>
                                                  </span>
                                            <span className="btn-inner--text">Continue editing service plan</span>
                                        </Button>
                                        <Button
                                            className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                            color="warning"
                                            onClick={() => this.clearDownDraft()}
                                        >
                                                  <span className="btn-inner--icon mr-1">
                                                    <RiDeleteBinFill title="Delete" size="16"/>
                                                  </span>
                                            <span className="btn-inner--text">Remove service plan</span>
                                        </Button>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </>}
                    {(
                        (sessionStorage.getItem("playlist"))
                    ) && <>
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <Card className="card-lift--hover shadow border-0 mb-4">
                                    <CardBody className="py-5">
                                        <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase d-flex align-items-center">
                                            <div className="icon icon-shape icon-shape-primary rounded-circle">
                                                <RiFolderMusicLine/>
                                            </div>
                                            <span className="ml-3">Service plan {JSON.parse(sessionStorage.getItem("playlist")).name}</span>
                                        </h2>
                                        <p className="description mt-3">
                                            What would you like to do with your {JSON.parse(sessionStorage.getItem("playlist")).name} service plan?
                                        </p>
                                        <Row className="mt-4 btn-wrapper">
                                            <Button
                                                className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                                color="primary"
                                                href="/scripture/curated-songs"
                                            >
                                                  <span className="btn-inner--icon mr-1">
                                                    <RiEditFill title="Edit" size="16"/>
                                                  </span>
                                                <span className="btn-inner--text">Continue editing {JSON.parse(sessionStorage.getItem("playlist")).name}</span>
                                            </Button>
                                            <Button
                                                className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                                color="warning"
                                                onClick={() => this.clearDownDraft()}
                                            >
                                                  <span className="btn-inner--icon mr-1">
                                                    <RiDeleteBinFill title="Delete" size="16"/>
                                                  </span>
                                                <span className="btn-inner--text">Start a new service plan</span>
                                            </Button>
                                            <Button
                                                className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                                color="primary"
                                                href="/your-profile/saved-song-flows"
                                            >
                                                  <span className="btn-inner--icon mr-1">
                                                    <RiFolderMusicLine title="View service plans" size="16"/>
                                                  </span>
                                                <span className="btn-inner--text">View your service plans</span>
                                            </Button>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </>}
                    <Row className="row-grid align-items-stretch">
                        <Col xs="12" sm="6" lg="3" className="d-flex">
                            <Card className="card-lift--hover shadow border-0 h-100 d-flex flex-column w-100">
                                <CardBody className="py-5 d-flex flex-column">
                                    <h2 className="text-primary text-uppercase d-flex align-items-center"
                                        style={{fontSize: '1rem'}}>
                                        <div className="icon icon-shape icon-shape-primary rounded-circle">
                                            <RiUserVoiceLine/>
                                        </div>
                                        <span className="ml-3">Song</span>
                                    </h2>

                                    <p className="description mt-3 flex-grow-1">
                                        {!sessionStorage.getItem("playlist")
                                            ? <>Build a worship service plan starting with a single song</>
                                            : <>Add a song by name
                                                to {JSON.parse(sessionStorage.getItem("playlist")).name}</>}
                                    </p>

                                    {/* content that can vary in height sits above; CTA sits at the bottom */}
                                    <div className="mt-auto twb-cta-group song-cta">
                                        <AutoCompleteInput navTo="/songs/search" />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" sm="6" lg="3" className="d-flex">
                            <Card className="card-lift--hover shadow border-0 h-100 d-flex flex-column w-100">
                                <CardBody className="py-5 d-flex flex-column">
                                    <h2 className="text-primary text-uppercase d-flex align-items-center" style={{fontSize: '1rem'}}>
                                        <div className="icon icon-shape icon-shape-primary rounded-circle">
                                            <RiBookMarkedFill/>
                                        </div>
                                        <span className="ml-3">Scripture</span>
                                    </h2>
                                    <p className="description mt-3 flex-grow-1">
                                        {!sessionStorage.getItem("playlist") && <>Find songs that match your Bible passage</>}
                                        {sessionStorage.getItem("playlist") && <>Add songs from scripture to {JSON.parse(sessionStorage.getItem("playlist")).name}</>}
                                        <br/>&nbsp;
                                    </p>
                                    <div className="mt-auto">
                                        <Button
                                            className="btn-icon mx-auto mb-0 twb-cta"
                                            color="primary"
                                            onClick={() => {
                                                // 1) fire the Recommended Event
                                                if (typeof window.gtag === 'function') {
                                                    window.gtag('event', 'select_content', {
                                                        content_type: 'navigation'
                                                    });
                                                }
                                                // 2) then navigate
                                                this.props.navigation('/scripture/choose-passages');
                                            }}                                                >
                                          <span className="btn-inner--icon mr-1">
                                            <RiBookMarkedFill/>
                                          </span>
                                          <span className="btn-inner--text">Build from Scripture</span>
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" sm="6" lg="3" className="d-flex">
                            <Card className="card-lift--hover shadow border-0 h-100 d-flex flex-column w-100">
                                <CardBody className="py-5 d-flex flex-column">
                                    <h2 className="text-primary text-uppercase d-flex align-items-center" style={{fontSize: '1rem'}}>
                                        <div
                                            className="icon icon-shape icon-shape-primary rounded-circle">
                                            <RiArchiveFill/>
                                        </div>
                                        <span className="ml-3">Theme</span>
                                    </h2>
                                    <p className="description mt-3 flex-grow-1">
                                        {!sessionStorage.getItem("playlist") && <>Find songs that match a worship theme</>}
                                        {sessionStorage.getItem("playlist") && <>Add songs from one or more themes to {JSON.parse(sessionStorage.getItem("playlist")).name}</>}
                                    </p>
                                    <div className="mt-auto">
                                        <Button
                                            className="btn-icon mx-auto mb-0 twb-cta"
                                            color="primary"
                                            onClick={() => {
                                                // 1) fire the Recommended Event
                                                if (typeof window.gtag === 'function') {
                                                    window.gtag('event', 'select_content', {
                                                        content_type: 'navigation'
                                                    });
                                                }
                                                // 2) then navigate
                                                this.props.navigation('/themes/choose-themes');
                                            }}                                                >
                                          <span className="btn-inner--icon mr-1">
                                            <RiArchiveFill/>
                                          </span>
                                          <span className="btn-inner--text">Build from a Theme</span>
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="12" sm="6" lg="3" className="d-flex">
                            <Card className="card-lift--hover shadow border-0 h-100 d-flex flex-column w-100">
                                <CardBody className="py-5 d-flex flex-column">
                                    <h2 className="text-primary text-uppercase d-flex align-items-center"  style={{fontSize: '1rem'}}>
                                        <div className="icon icon-shape icon-shape-primary rounded-circle">
                                            <RiBookFill/>
                                        </div>
                                        <span className="ml-3">Lectionary</span>
                                    </h2>
                                    <p className="description mt-3 flex-grow-1">
                                        {!sessionStorage.getItem("playlist") && <>Build a worship service plan from a Lectionary</>}
                                        {sessionStorage.getItem("playlist") && <>Add songs from a lectionary to {JSON.parse(sessionStorage.getItem("playlist")).name}</>}
                                        <br/>&nbsp;
                                    </p>
                                    <div className="mt-auto">
                                        <Button
                                            className="btn-icon mx-auto mb-0 twb-cta"
                                            color="primary"
                                            onClick={() => {
                                                // 1) fire the Recommended Event
                                                if (typeof window.gtag === 'function') {
                                                    window.gtag('event', 'select_content', {
                                                        content_type: 'navigation'
                                                    });
                                                }
                                                // 2) then navigate
                                                this.props.navigation('/lectionary/choose-lectionary');
                                            }}
                                        >
                                          <span className="btn-inner--icon mr-1">
                                            <RiBookFill/>
                                          </span>
                                          <span className="btn-inner--text">
                                              Build from a lectionary
                                          </span>
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col>
                            <CuratedSongFlowSignupBanner />
                        </Col>
                    </Row>
                    <Row className="row-grid align-items-center">
                        <Col className="order-md-2" md="6">
                            <img
                                alt="A person worshipping during a church service"
                                className="img-fluid rounded"
                                src={require("../assets/images/worshiper.jpg")}
                            />
                        </Col>
                        <Col className="order-md-1" md="6">
                            <div className="pr-md-5">
                                <h2 className="display-3 text-primary">
                                    <span>how it works</span>
                                </h2>
                                <p>
                                    We bring together Scripture, song, and structure to help you plan worship with
                                    confidence.
                                    Using trusted songbooks and biblical themes, The Worship Bible helps you create
                                    worship service plans that serve the whole Act of Worship — from gathering to sending.
                                </p>
                                <ul className="list-unstyled mt-5">
                                    <li className="py-2">
                                        <div className="d-flex">
                                            <Badge
                                                className="badge-circle mr-3 mt-2 align-self-start"
                                                color="primary"
                                            >
                                                <RiBookFill color="white"/>
                                            </Badge>

                                            <div>
                                                <h3 className="text-primary font-weight-light mb-2 h2">
                                                    tradition meets innovation
                                                </h3>

                                                <p className="mb-0 text-muted">
                                                    Build worship sets around lectionary readings, sermon themes, or
                                                    specific Bible passages, drawing on both time-honoured tradition and
                                                    contemporary worship music.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="py-2">
                                        <div className="d-flex">
                                            <Badge
                                                className="badge-circle mr-3 mt-2 align-self-start"
                                                color="primary"
                                            >
                                                <RiFlowChart color="white"/>
                                            </Badge>

                                            <div>
                                                <h3 className="text-primary font-weight-light mb-2 h2">
                                                    curated for impact
                                                </h3>

                                                <p className="mb-0 text-muted">
                                                    Each worship service plan is intentionally shaped to support Scripture,
                                                    strengthen congregational engagement, and serve the wider flow of
                                                    worship — not just the music slot.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="py-2">
                                        <div className="d-flex">
                                            <Badge
                                                className="badge-circle mr-3 mt-2 align-self-start"
                                                color="primary"
                                            >
                                                <RiCompass2Fill color="white"/>
                                            </Badge>

                                            <div>
                                                <h3 className="text-primary font-weight-light mb-2 h2">
                                                    simple and purposeful
                                                </h3>

                                                <p className="mb-0 text-muted">
                                                Choose your focus, select your songs, arrange the flow, and share it
                                                    with your team — so you can spend less time searching and more time
                                                    leading worship well.
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center mt-6 twb-home-cta">
                        <Col md="8" className="text-center">
                            <Button
                                color="link"
                                className="font-weight-bold text-primary p-0"
                                onClick={() => this.props.navigation('/benefits')}
                            >
                                See how The Worship Bible supports your worship planning →
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    }
}

export default withNavigateHook(Index);
